import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import EditText from '../../../../components/base/edit-text/edit-text';
import Button from '../../../../components/base/button/button';
import i18n from '../../../../translations/strings';
import { ChangePasswordFormStyled } from './change-password-form.styled';

const ChangePasswordForm = (props: any) => {
  const {
    control,
    formState: { errors },
    register,
    handleSubmit,
  } = useFormContext();

  return (
    <ChangePasswordFormStyled.Container>
      <Controller
        control={control}
        rules={{
          required: true,
        }}
        render={({ field: { onChange, value } }) => (
          <EditText
            isPassword
            error={errors?.password?.message?.toString()}
            fullWidth
            {...register('password')}
            defaultValue={value}
            placeholder={i18n.t('common.oldPassword')}
            onChange={onChange}
            label={i18n.t('common.oldPassword')}
          />
        )}
        name="password"
      />

      <Controller
        control={control}
        rules={{
          required: true,
        }}
        render={({ field: { onChange, value } }) => (
          <EditText
            isPassword
            error={errors?.new_password?.message?.toString()}
            fullWidth
            {...register('new_password')}
            defaultValue={value}
            placeholder={i18n.t('common.password')}
            onChange={onChange}
            label={i18n.t('common.password')}
          />
        )}
        name="new_password"
      />
      <ChangePasswordFormStyled.Separator />
      <Controller
        control={control}
        rules={{ required: true }}
        render={({ field: { onChange, value } }) => (
          <EditText
            isPassword
            error={errors?.confirm_password?.message?.toString()}
            fullWidth
            {...register('confirm_password')}
            defaultValue={value}
            placeholder={i18n.t('registration.confirmPassword')}
            onChange={onChange}
            label={i18n.t('registration.confirmPassword')}
          />
        )}
        name="confirm_password"
      />
      <ChangePasswordFormStyled.Separator />
      <ChangePasswordFormStyled.ContainerButton>
        <Button
          onClick={handleSubmit(props.onSubmit, props.onError)}
          label={i18n.t('registration.changePassword')}
        />
      </ChangePasswordFormStyled.ContainerButton>
    </ChangePasswordFormStyled.Container>
  );
};

export default ChangePasswordForm;
